import React,{useState} from "react";
// import { Button, Grid, Box } from "@mui/material";

import { useNavigate } from "react-router-dom";
import MobileDrawer from "../MobileComponents/MobileDrawer";
import avtar from "../../../MobileScreens/assets/images/Profile-Picture.jpg";
import CreateIcon from "@mui/icons-material/Create";
import IconButton from "@mui/material/IconButton";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailIcon from "@mui/icons-material/Mail";
import PeopleIcon from "@mui/icons-material/People";
import ApartmentIcon from "@mui/icons-material/Apartment";
import document from "../../../MobileScreens/assets/images/updated-aadhaar.png";
import Zoom from "react-medium-image-zoom";
import ProfileBottomTab from "../MobileComponents/ProfileBottomTab";

function MobileProfile() {
  const navigate = useNavigate();
  const [aptListShowHide, setAptListShowHide] = useState(false);
  return (
    <>
      <div>
        <div className="drawerFixedPatch"></div>
        <div className="drawerWithTop">
          <MobileDrawer />
          <h1>My Profile</h1>
        </div>
      </div>
      <div className="wraperMobile">
        <div className="sectionMobile">
          <div className="mobProHed">
            <div onClick={()=>navigate('/MobileEditProfile')}>
              <IconButton className="mobPropEdit">
                <CreateIcon />
              </IconButton>
            </div>
            <div className="mobProHedInr">
              <em className="smTxMob">Public</em>
              <div className="mobProHedInrProOut">
                <div className="mobProHedInrProFilePic">
                  <img src={avtar} alt='altimg'/>
                </div>
              </div>
              <h1>Namrata Patil</h1>
              <p>26 Years (Owner Resident)</p>
              <p>SaiSaya/A/F-1301 Owner Occupied Parking P-1301</p>
              {aptListShowHide ? <><p>SaiSaya/A/F-1303 Tenant Occupied Parking P-1303</p>
              <p>Hari Akruti1/wing A/401 Owner Occupied Parking P-401</p>
              <p>SaiSaya/A/F-1302 Tenant Occupied Parking P-1302</p></>:null}
              <b onClick={() => setAptListShowHide(!aptListShowHide)}>{aptListShowHide ? <>Minimize</> : <>View All Appartments</>}
              </b>
            </div>
          </div>
        </div>

        <div className="sectionMobile">
          <div className="mobProDetailsMain">
            <h1 className="mobContMainHeading">Details</h1>
            <div>
              <div className="mobProDetaiInr">
                <LocalPhoneIcon /> <span>8830789836</span>
              </div>
              <div className="mobProDetaiInr">
                <MailIcon /> <span>namratap.supra@gmail.com</span>
              </div>
              <div className="mobProDetaiInr">
                <PeopleIcon /> <span>5 Members</span>
              </div>
              <div className="mobProDetaiInr">
                <ApartmentIcon />{" "}
                <span>
                  Owner Resident: <br /> SaiSaya/A/F-1301 Occupied since:
                  02-01-2024
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="sectionMobile">
          <div className="mobDocumentMain">
            <h1 className="mobContMainHeading">Document's</h1>
            <div>
              <div className="mobDocumentInr">
                <div className="mobDocumentPrev">
                  <Zoom>
                    <img src={document} alt='altimg'/>
                  </Zoom>
                </div>
                <h1 className="MobUploadedtx">uploaded file</h1>
              </div>

              <div className="mobDocumentInr">
                <div className="mobDocumentPrev">
                  <Zoom>
                    <img src={document} alt='altimg'/>
                  </Zoom>
                </div>
                <h1 className="MobUploadedtx">uploaded file</h1>
              </div>

              <div className="mobDocumentInr">
                <div className="mobDocumentPrev">
                  <Zoom>
                    <img src={document} alt='altimg'/>
                  </Zoom>
                </div>
                <h1 className="MobUploadedtx">uploaded file</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ProfileBottomTab />
    </>
  );
}

export default MobileProfile;
